<header class="">
  <div class="header-hold">
    <span
      class="se-icon-burger_menu hide-in-large"
      (click)="openSideMenu($event)"
    ></span>
    <a class="navbar-brand" href="#">
      <div class="row m-0 position-relative mrgLft3">
        <span class="app-name">{{ labels.automationService }}</span>
        <span class="app-ext">{{ labels.portal }}</span>
      </div>
    </a>
    <div class="navbar-brand header-right-menu float-right">
      <div class="row">
        <div class="col-auto">
          <div class="dropdown hide-in-mobile">
            <a
              class="dropdown-toggle user-menu"
              data-toggle="dropdown"
              (click)="userDropDown($event)"
            >
              <span class="se-icon-user_standard"></span
              >{{ loggedInUser || user.email || "IDMS user" }}
            </a>
            <div class="dropdown-menu" [ngClass]="{ show: showDropdown }">
              <a
                *ngIf="isInternalUser != 'true'"
                class="dropdown-item"
                href="{{ urls.profileUpdate + '&lang=' + language }}"
                >{{ labels.profileUpdate }}</a
              >
              <a
                *ngIf="isInternalUser != 'true'"
                class="dropdown-item"
                href="{{ urls.pwdUpdate + '&lang=' + language }}"
                >{{ labels.changePassword }}</a
              >
              <a
                *ngIf="isInternalUser != 'true'"
                class="dropdown-item"
                href="{{ urls.emailUpdate + '&lang=' + language }}"
                >{{ labels.changeEmail }}</a
              >
              <a class="dropdown-item cursor-pointer" (click)="logout()">{{
                labels.logout
              }}</a>
            </div>
          </div>
        </div>
        <div class="col-auto hide-sm">
          <img
            class="logo"
            src="assets/image/se-logo-green.svg"
            alt="{{ labels.schneiderElectric }}"
            title="{{ labels.schneiderElectric }}"
            height="30"
            width="90"
          />
        </div>
      </div>
    </div>
  </div>
</header>

<div class="side-menu hide-in-large" *ngIf="showSidePanel">
  <div class="overlay">
    
    <div style="background-color: rgb(0 0 0 / 80%);"> 
      <div class="profile-details">
        <span class="se-icon-user_standard"></span
        > <span> {{ loggedInUser || user.email || "IDMS user" }} </span>
      </div>
      <div>
        <img class="pwalogo"
          src="assets/image/se-logo-green.svg"
          alt="{{ labels.schneiderElectric }}"
          title="{{ labels.schneiderElectric }}"
          height="45"
          width="102"
        />
      </div>
    </div>
    
    <ul class="list-items">
      <li>
        <a
          *ngIf="isInternalUser != 'true'"
          class="dropdown-item"
          href="{{ urls.profileUpdate + '&lang=' + language }}"
          >{{ labels.profileUpdate }}</a
        >
      </li>
      <li>
        <a
          *ngIf="isInternalUser != 'true'"
          class="dropdown-item"
          href="{{ urls.pwdUpdate + '&lang=' + language }}"
          >{{ labels.changePassword }}</a
        >
      </li>
      <li>
        <a
          *ngIf="isInternalUser != 'true'"
          class="dropdown-item"
          href="{{ urls.emailUpdate + '&lang=' + language }}"
          >{{ labels.changeEmail }}</a
        >
      </li>
      <li>
        <a class="dropdown-item cursor-pointer" (click)="logout()">{{ labels.logout }}</a>
      </li>
    </ul>
    
    <div class="footer" style="position: absolute; bottom: 0">
      <div class="row justify-content-center align-items-center pptc">
          <div>
              <div class="text-left" style="font-size: 12px;">
                  <a [download]="privacyPolicyFileName" [href]="privacyPolicyFilePath" target="blank" style="text-decoration: underline;">{{labels.privacyPolicy}}</a>
                  <a [download]="termsAndConditionsFileName" [href]="termsAndConditionsFilePath"target="blank" style="text-decoration: underline;">{{labels.termsAndConditions}}</a>
              </div>
          </div>
      </div>
      <div class="row justify-content-center align-items-center" style="margin-left: 5px;">
        <p>&copy; {{currentYear}},{{labels.footerCopyright}}</p>
      </div>
    </div>

  </div>
</div>
